var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.stocks),function(stk){return _c('Stock',{key:stk.id,attrs:{"stock":stk}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }